import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const cityService = {
    async getDropdownAsync()
    {
         const response=await apiClient.get(endPoints.city.dropdown);
         return response.data
       
    },
     async getAllAsync(params) {
    const response = await apiClient.get(endPoints.city.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.city.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  async getAllByCountryAsync(countryId, params) {
    const response = await apiClient.get(
      `${endPoints.city.getAllByCountry}/${countryId}`,
      { params: params },
    );

    return response.data;
  },
  async getDropdownByCountryAsync(countryId) {
    const response = await apiClient.get(
      `${endPoints.city.dropdownByCountry}/${countryId}`,
    );
    return response.data;
  },
  async toggleActivate(id) {
    const response = await apiClient.patch(
      `${endPoints.city.toggleActivate}/${id}`,
    );
    return response.data;
  },
  async create(data) {
    const response = await apiClient.post(endPoints.city.create, data);
    return response.data;
  },
  async update(id, data) {
    const response = await apiClient.post(
      `${endPoints.city.update}/${id}`,
      data,
    );
    return response.data;
  },
  async edit(id) {
    const response = await apiClient.get(`${endPoints.city.edit}/${id}`);
    return response.data;
  },
  async deleteImageAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.city.deleteImage}/${id}`,
    );
    return response.data;
  },
   async deleteAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.city.delete}/${id}`,
    );
    return response.data;
  },
  async getDetails(id) {
    const response = await apiClient.get(
      `${endPoints.city.getDetails}/${id}`,
    );
    return response.data;
  }
}